export const merchandise = [
  {
    id: 1,
    name: 'Marche Premium Hoodie',
    category: 'Apparel',
    price: 79,
    image: 'https://public.readdy.ai/ai/img_res/068678a089108904affb5e3d450f9c28.jpg'
  },
  {
    id: 2,
    name: 'Marche Performance T-Shirt',
    category: 'Apparel',
    price: 39,
    image: 'https://readdy.ai/api/search-image?query=black%20performance%20t-shirt%20with%20electric%20blue%20futuristic%20logo%20design%20on%20dark%20background%20athletic%20wear%20studio%20photography%20high%20quality%20fabric%20modern%20minimalist%20style%20premium%20sportswear&width=400&height=400&seq=merch2&orientation=squarish'
  },
  {
    id: 3,
    name: 'Marche Snapback Cap',
    category: 'Apparel',
    price: 45,
    image: 'https://readdy.ai/api/search-image?query=black%20snapback%20cap%20with%20blue%20glowing%20embroidered%20logo%20on%20dark%20background%20premium%20headwear%20studio%20photography%20modern%20streetwear%20style%20high%20quality%20materials%20futuristic%20design&width=400&height=400&seq=merch3&orientation=squarish'
  },
  {
    id: 4,
    name: 'Premium Ceramic Wax',
    category: 'Products',
    price: 89,
    image: 'https://readdy.ai/api/search-image?query=luxury%20car%20ceramic%20wax%20bottle%20black%20packaging%20with%20blue%20accents%20on%20dark%20background%20professional%20product%20photography%20high-end%20automotive%20detailing%20product%20modern%20minimalist%20design%20premium%20quality&width=400&height=400&seq=merch4&orientation=squarish'
  },
  {
    id: 5,
    name: 'Microfiber Towel Set',
    category: 'Products',
    price: 49,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20microfiber%20towels%20stacked%20neatly%20with%20blue%20trim%20on%20dark%20background%20professional%20product%20photography%20automotive%20detailing%20supplies%20high%20quality%20fabric%20modern%20minimalist%20style&width=400&height=400&seq=merch5&orientation=squarish'
  },
  {
    id: 6,
    name: 'Detailing Spray Kit',
    category: 'Products',
    price: 69,
    image: 'https://readdy.ai/api/search-image?query=professional%20car%20detailing%20spray%20bottles%20set%20black%20packaging%20with%20blue%20labels%20on%20dark%20background%20premium%20automotive%20cleaning%20products%20studio%20photography%20modern%20design%20high%20quality&width=400&height=400&seq=merch6&orientation=squarish'
  },
  {
    id: 7,
    name: 'Marche Windbreaker',
    category: 'Apparel',
    price: 99,
    image: 'https://readdy.ai/api/search-image?query=black%20windbreaker%20jacket%20with%20futuristic%20blue%20glowing%20logo%20on%20dark%20background%20premium%20outerwear%20fashion%20photography%20modern%20athletic%20style%20high%20quality%20materials%20sleek%20design&width=400&height=400&seq=merch7&orientation=squarish'
  },
  {
    id: 8,
    name: 'Foam Cannon Pro',
    category: 'Products',
    price: 129,
    image: 'https://readdy.ai/api/search-image?query=professional%20foam%20cannon%20car%20wash%20equipment%20black%20with%20blue%20accents%20on%20dark%20background%20automotive%20detailing%20tool%20product%20photography%20modern%20design%20high%20quality%20materials%20premium%20grade&width=400&height=400&seq=merch8&orientation=squarish'
  }
];